"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/styles");
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _HeaderActions = _interopRequireDefault(require("../HeaderActions"));
var _NavItem = _interopRequireDefault(require("../Navbar/NavItem"));
var _styles2 = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MobileHeader = _ref => {
  let {
    classes,
    isLoggedIn,
    mobileNavLinks,
    mobileDropDown,
    LoggedInActions,
    LoggedOutActions,
    color
  } = _ref;
  const [openMobileMenu, setOpenMobileMenu] = (0, _react.useState)(false);
  const stopProgationOfEventToHeader = e => {
    e.stopPropagation();
  };
  const toggleMobileMenu = e => {
    stopProgationOfEventToHeader(e);
    setOpenMobileMenu(!openMobileMenu);
  };
  if (!openMobileMenu) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${classes.hamburger} ${color === "white" && classes.whiteHamburger}`,
      onClick: toggleMobileMenu
    }, /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null), /*#__PURE__*/_react.default.createElement("span", null));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${classes.mobileNavContainer} ${color === "white" && classes.whiteHeader}`,
    onClick: stopProgationOfEventToHeader
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.closeMenuIcon
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    onClick: toggleMobileMenu
  })), /*#__PURE__*/_react.default.createElement("nav", {
    className: classes.mobileNavigation
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: `${isLoggedIn ? null : classes.hideNav} ${color === "white" && classes.whiteHeader}`
  }, mobileNavLinks && mobileNavLinks.map(tab => /*#__PURE__*/_react.default.createElement(_NavItem.default, {
    key: tab.label,
    title: tab.label,
    link: tab.to,
    active: tab.active
  })), mobileDropDown && mobileDropDown.map(dropdown => /*#__PURE__*/_react.default.createElement("div", {
    key: dropdown.label,
    className: classes.subMenues
  }, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_NavItem.default, {
    title: dropdown.label,
    subHeader: true
  }), dropdown.list.map(item => /*#__PURE__*/_react.default.createElement(_NavItem.default, {
    key: item.label,
    title: item.label,
    link: item.link,
    subListItem: true
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mobileActionBtns
  }, /*#__PURE__*/_react.default.createElement(_HeaderActions.default, {
    isLoggedIn: isLoggedIn,
    LoggedInActions: LoggedInActions,
    LoggedOutActions: LoggedOutActions,
    headerType: "mobile"
  }))));
};
var _default = exports.default = (0, _styles.withStyles)(_styles2.useStyles)(MobileHeader);